import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import PageHeader from '../components/PageHeader';
import ConfigurationWarning from '../components/common/ConfigurationWarning';

// Import the tab components
import SettingsTab from '../components/order-sync/SettingsTab';
import SyncedOrdersTab from '../components/order-sync/SyncedOrdersTab';
import ComponentSelector from '../components/order-sync/ComponentSelector';

export default function OrderSync() {
  const location = useLocation();

  // Determine active tab based on the current URL
  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path.includes('/order-sync/orders')) return 0;
    if (path.includes('/order-sync/settings')) return 1;
    return 0; // Default to sync operations
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

  // Update active tab when the location changes
  useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location]);

  return (
    <Box>
      <PageHeader
        title='Order Synchronization'
        subtitle='Orders are synced from Shopify to ERP using the Shopify Webhook'
      />

      <ConfigurationWarning>
        <ComponentSelector />

        {/* Render the active tab content */}
        {activeTab === 0 && <SyncedOrdersTab />}
        {activeTab === 1 && <SettingsTab />}
      </ConfigurationWarning>
    </Box>
  );
}
